export const DeletePermanentRedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <path id="delete_forever_24dp_FILL1_wght400_GRAD0_opsz24" d="M165.4-826.5l2.6-2.6,2.6,2.6,1.4-1.4-2.6-2.6,2.6-2.6-1.4-1.4-2.6,2.6-2.6-2.6-1.4,1.4,2.6,2.6-2.6,2.6ZM163-822a1.926,1.926,0,0,1-1.413-.588A1.926,1.926,0,0,1,161-824v-13h-1v-2h5v-1h6v1h5v2h-1v13a1.926,1.926,0,0,1-.587,1.412A1.926,1.926,0,0,1,173-822Z" transform="translate(-160 840)" fill="#b20c00"/>
  </svg>
);
